import { useState } from 'react';

import FeedbackIconButton from './feedback-icon-button';
import thumbsDownActive from './feedback-icon-button/feedback-icons/ThumbsDown/thumbs-down-active.svg';
import thumbsDownHover from './feedback-icon-button/feedback-icons/ThumbsDown/thumbs-down-hover.svg';
import thumbsDownNormal from './feedback-icon-button/feedback-icons/ThumbsDown/thumbs-down-normal.svg';
import thumbsUpActive from './feedback-icon-button/feedback-icons/ThumbsUp/thumbs-up-active.svg';
import thumbsUpHover from './feedback-icon-button/feedback-icons/ThumbsUp/thumbs-up-hover.svg';
import thumbsUpNormal from './feedback-icon-button/feedback-icons/ThumbsUp/thumbs-up-normal.svg';

import styles from './styles.module.scss';

interface WasSummaryHelpfulProps {
  onPositiveFeedbackForSummary: () => void;
  onNegativeFeedbackForSummary: () => void;
  resources: {
    wasSummaryHelpful: string;
    summaryWasHelpfulAriaLabel: string;
    summaryWasNotHelpfulAriaLabel: string;
  };
}

const WasSummaryHelpful: React.FC<WasSummaryHelpfulProps> = props => {
  const [selectedFeedback, setSelectedFeedback] = useState<'helpful' | 'notHelpful' | null>(null);

  const handleHelpfulClick = (): void => {
    setSelectedFeedback(selectedFeedback === 'helpful' ? null : 'helpful');
    props.onPositiveFeedbackForSummary();
  };

  const handleNotHelpfulClick = (): void => {
    setSelectedFeedback(selectedFeedback === 'notHelpful' ? null : 'notHelpful');
    props.onNegativeFeedbackForSummary();
  };

  return (
    <div className={styles['summary__survey']}>
      <span>{props.resources.wasSummaryHelpful}</span>
      <FeedbackIconButton
        icons={{
          normal: thumbsUpNormal,
          hover: thumbsUpHover,
          active: thumbsUpActive,
        }}
        ariaLabel={props.resources.summaryWasHelpfulAriaLabel}
        onClick={handleHelpfulClick}
        isSelected={selectedFeedback === 'helpful'}
      />
      <FeedbackIconButton
        icons={{
          normal: thumbsDownNormal,
          hover: thumbsDownHover,
          active: thumbsDownActive,
        }}
        ariaLabel={props.resources.summaryWasNotHelpfulAriaLabel}
        onClick={handleNotHelpfulClick}
        isSelected={selectedFeedback === 'notHelpful'}
      />
    </div>
  );
};

export default WasSummaryHelpful;
